module.exports = __webpack_public_path__ + "img/ZJ5295.42d4ce71.png";